import { FC, useEffect } from 'react';
import * as Styled from '../Seating.styled';
import { GaEvent, handleFormatGuestsAndTimeSelections } from '@maverick/utils';
import { SeatingStepsReduxProps } from '.';
import Router from 'next/router';

interface SeatingSuccess extends SeatingStepsReduxProps {}

export const SeatingSuccess: FC<SeatingSuccess> = ({ seatingData, resetSeatingDataModify }) => {
	useEffect(() => {
		const guestsAndSelectedTime = handleFormatGuestsAndTimeSelections(seatingData.Guests, seatingData.Datetime);
		GaEvent.GetOnTheListComplete(Number(seatingData.LocationId), guestsAndSelectedTime);

		resetSeatingDataModify();
	}, []);

	const handleViewDetails = () => {
		GaEvent.InternalLinkClick('/seating/details');
		Router.push('/seating/details');
	};

	return (
		<Styled.Success>
			<Styled.SuccessContent>
				<h1>See you soon {seatingData.FirstName}!</h1>
				<h2>We've sent you an email with all of the details. Did someone say steak?</h2>
				<div>
					<Styled.Button onClick={handleViewDetails}>View details</Styled.Button>
				</div>
				<p>
					Savor the savings by joining the Dine Rewards program and start earning points on your visit!{' '}
					<a href='https://dine-rewards.com/?utm_campaign=brand-website&utm_medium=email&utm_content=news&utm_source=outback'>
						Sign up now
					</a>
					.
				</p>
			</Styled.SuccessContent>
		</Styled.Success>
	);
};
